export abstract class AbstractEndpoints {

    advertisement!: IAdvertisementEndpoints;
    authorization!: IAuthorizationEndpoints;
    azureStorage!: IAzureStorageEndpoints;
    campaigns!: ICampaignsEndpoints;
    campaignInsights!: ICampaignInsightsEndpoints;
    menu!: IMenuEndpoints
    notifications!: INotificationEndpoints;
    organization!: IOrganizationEndpoints;
    token!: ITokenEndpoints;
}
export interface IAdvertisementEndpoints {
    deleteAdvertisement(organizationId: string, advertisementId: string): string;
}
export interface IAuthorizationEndpoints {
    login: string;
    passwordReset: string;
    profileEdit: string;
    signup: string;
    loginRedirect: string;
    registerRedirect: string;
}

export interface IAzureStorageEndpoints {
    base: string;
}

export interface ICampaignsEndpoints {
    campaignConfig(organizationId: string, campaignId: string): string;
    campaignRedirectFile(organizationId: string, campaignId: string): string;
    campaignSubscriptionFile(organizationId: string, campaignId: string): string;
}

export interface ICampaignInsightsEndpoints {
    getPageViews(url: string, startDate: Date, endDate: Date): string;
}

export interface IMenuEndpoints {
    loadMenuFile(organizationId: string, campaignId: string): string;
}

export interface INotificationEndpoints {
    sendNotification: string;
}

export interface IOrganizationEndpoints {
    updateOrganization: string;
    organizationSubscriptionFile(organizationId: string): string;
}

export interface ITokenEndpoints {
    getSASCRUDToken(containerName?: string): string;
    getSASAppendToken(fileName: string): string;
    getSASTokenForFolder(containerName?: string, folderName?: string): string;
}
